export default "__VITE_ASSET__DZ2_OcWR__"